import React from 'react';
import Helmet from 'react-helmet';
import { Config } from '../../config/index';
import { Redirect, Link } from 'react-router-dom';
import findIndex from 'lodash.findindex';
import './StaticPage.css';
import { AppContext } from '../../Context';
import { IRootState } from '../../definitions/root';
import Actions from '../../actions';
import { isEmptyHTML } from '../../services/utils';
import StaticBanner from '../../components/StaticBanner/index';

export default function StaticPageRender(props, state) {
  if (Actions.requestFinished(this.request) && !this.page) {
    return <Redirect to="/not-found" />;
  }

  if (!this.page) {
    return null;
  }

  const { title, subtitle, abstract, banner, banner_mobile, body, url } = this.page;

  const OurHistoryNav = () => {
    return (
      <div className="static-header">
        <div className="static-pagination-container">
          <ul className="static-pagination">
            <OurHistoryLinks />
          </ul>
        </div>
      </div>
    );
  };

  const OurHistoryLinks = () => {
    const selectedPageIndex = this.historyPages ? findIndex(this.historyPages, { title: this.page.title }) : null;

    return this.historyPages.map((page, i) =>
      <li key={i}>
        <Link
          to={page.url}
          className={selectedPageIndex === i ? 'active' : ''}>
          {page.title}
        </Link>
      </li>
    );
  };

  return (
    <AppContext.Consumer>
      {({ app: { isMobile, isTablet } }: IRootState) => {
        const bannerImage = !isMobile && !isTablet ? banner : banner_mobile;

        return (
          <React.Fragment>
            <Helmet>
              <title>{title}</title>
              <link rel="canonical" href={`${Config.FRONT_END_URL}/${url}`} />
              <meta name="description" content={abstract} />
            </Helmet>

            <div className={`page page--static ${this.pageType}`}>
              {this.isHistoryPage &&
                <StaticBanner
                  bannerImg={{
                    src: bannerImage,
                    srcSet: `${bannerImage} 240w`,
                    sizes: `"
                      (min-width: 320px) 420px,
                      (min-width: 768px) 380px,
                      (min-width: 1024px) 520px,
                      (min-width: 1200px) 640px
                    "`,
                  }}
                />}

              {this.isHistoryPage && <OurHistoryNav />}

              {this.isStandardPage &&
                <StaticBanner
                  title={title}
                  subtitle={subtitle}
                  bannerImg={{
                    src: bannerImage,
                    srcSet: `${bannerImage} 240w`,
                    sizes: `"
                      (min-width: 320px) 420px,
                      (min-width: 768px) 380px,
                      (min-width: 1024px) 520px,
                      (min-width: 1200px) 640px
                    "`,
                  }}
                />}

              <div className="container">
                <div className="static-content">
                  {this.isHistoryPage &&
                    <div className="content-heading">
                      <h2 className="title">{title}</h2>
                      <p className="subtitle">{subtitle}</p>
                    </div>}

                  {!isEmptyHTML(body) &&
                    <div
                      className="content"
                      dangerouslySetInnerHTML={{ __html: body }} />}
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      }}
    </AppContext.Consumer>
  );
}



// WEBPACK FOOTER //
// ./src/containers/StaticPage/render.tsx